<div class="flex gap-2 justify-between">
  <app-confirm-dialog
    [show]="showConfirmDialog"
    [message]="message"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
  ></app-confirm-dialog>
  <app-select
    [formControl]="clientId"
    placeholder="Cliente"
    [options]="clientOptions"
    class="flex-1"
    *kaHasRoles="['admin']; resource: 'tefbox-api-lojista'"
  ></app-select>
  <app-select
    [formControl]="merchantId"
    placeholder="Estabelecimento"
    [options]="merchantOptions"
    class="flex-1"
    *kaHasRoles="['admin', 'cliente']; resource: 'tefbox-api-lojista'"
  ></app-select>
</div>
<div class="flex justify-end mt-4">
  <app-button (click)="openModal()">Adicionar</app-button>
  <app-modal [show]="showModal" (close)="closeModal()" title="Registrar Checkout">
    <div class="w-[500px]">
      <app-input placeholder="Apelido" [formControl]="checkoutLabel"></app-input>

      <div class="flex justify-end mt-4">
        <app-button (click)="salvar()">Salvar</app-button>
      </div>
    </div>
  </app-modal>

  <app-terminal
    [showModal]="showTerminalModal"
    [title]="selectedCheckoutLabel"
    (closeModal)="closeTerminalModal()"
    [merchantId]="merchantId.value"
    [checkoutId]="selectedCheckout"
  ></app-terminal>
</div>
<app-loading [show]="loading"></app-loading>
<app-table [columns]="columns" [data]="data"></app-table>
